import { useState, useEffect } from 'react';

import { HISTORICAL_PERIOD_OPTION } from '../../../shared/constants/benefits';
import MetricsByCompany from '../../../shared/services/api/metrics/metricsByCompany/metrics';

export const useBenefitInsight = (companyId: string, benefitId: string) => {
  const [intendedUses, setIntendedUses] = useState<number>(-1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const fetchInsight = async () => {
    setLoading(true);
    try {
      const response = await MetricsByCompany.getBenefitsMetrics(
        companyId,
        HISTORICAL_PERIOD_OPTION,
        undefined,
        undefined,
        benefitId
      );
      setIntendedUses(response.topBenefits[0]?.intendedUses ?? 0);
      setError(false);
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (companyId && benefitId) {
      fetchInsight();
    }
  }, [companyId, benefitId]);

  return { intendedUses, loading, error, refetch: fetchInsight };
};
